export enum ActiveShiftTabEnum {
  Today = 0,
  PendingReview = 1,
}
